import type { Sticker } from '../types';

export const holi: Sticker[] = [
  {
    id: 26001,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/001-holi.png',
    name: 'Święto Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26002,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/002-holi.png',
    name: 'Kolory Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26003,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/003-holi.png',
    name: 'Proszek Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26004,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/004-holi.png',
    name: 'Festiwal Kolorów',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26005,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/005-holi.png',
    name: 'Radość Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26006,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/006-holi.png',
    name: 'Zabawa Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26007,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/007-holi.png',
    name: 'Taniec Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26008,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/008-holi.png',
    name: 'Muzyka Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26009,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/009-holi.png',
    name: 'Tradycja Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26010,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/010-holi.png',
    name: 'Świętowanie Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26011,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/011-holi.png',
    name: 'Kolorowy Proszek',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26012,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/012-holi.png',
    name: 'Wiosenne Holi',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26013,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/013-holi.png',
    name: 'Indyjskie Święto',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26014,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/014-holi.png',
    name: 'Kolorowa Zabawa',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26015,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/015-holi.png',
    name: 'Radosne Święto',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26016,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/016-holi.png',
    name: 'Festiwal Wiosny',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26017,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/017-holi.png',
    name: 'Kolorowy Taniec',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26018,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/018-holi.png',
    name: 'Holi Razem',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26019,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/019-holi.png',
    name: 'Kolorowa Radość',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 26020,
    url: 'https://stickers.nauczniaczek.pl/colections/14880305-holi/png/020-holi.png',
    name: 'Holi Święto',
    category: 'holi',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];